import reduce from 'lodash/reduce';
import concat from 'lodash/concat';
import {
  extractDistributionData,
  extractDistributionGroupData
} from './distribution';
import { extractAuctionData } from './auction';
import { extractOnlineSalesGroupData } from './online';
import { extractPressData } from './press';
import { extractNotationData } from './notation';

export function extractFeedData(response) {
  return reduce(
    Object.keys(response),
    (acc, key) => concat(acc, getFeedExtractor(key, response[key])),
    []
  ).sort((a, b) => b.momentDate.diff(a.momentDate));
}

function getFeedExtractor(key, data) {
  switch (key) {
    case 'Caves':
    case 'Restaurants':
      return extractDistributionGroupData(data, key);
    case 'Vente aux enchères':
      return extractAuctionData(data);
    case 'Ventes Primeur':
      return extractDistributionData(data, key);
    case 'Ventes en Ligne':
      return extractOnlineSalesGroupData(data);
    case 'Presse':
      return extractPressData(data);
    case 'Notations':
      return extractNotationData(data);
    default:
      return [];
  }
}
